import { createAction } from '@reduxjs/toolkit';
export const fetchPersonalTasks = createAction('personalTasks/fetchPersonalTasks');
export const updatePersonalTaskSagaAction = createAction('personalTasks/updatePersonalTaskSagaAction');
export const deletePersonalTaskSagaAction = createAction('personalTasks/deletePersonalTaskSagaAction');
export const createPersonalTaskSagaAction = createAction('personalTasks/createPersonalTask');
